import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function LineCtaSection() {
  const anim = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=elegant%20women%20fashion%20boutique%20interior%20warm%20rose%20beige%20cream%20tones%20soft%20golden%20light%20luxury%20atmosphere%20clothing%20display%20designer%20brand%20quality%20fabric%20graceful&width=1400&height=700&seq=cta001&orientation=landscape"
        alt="加入LINE"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#3d2b1f]/60 via-[#3d2b1f]/50 to-[#3d2b1f]/65" />
      <div
        ref={anim.ref as React.RefObject<HTMLDivElement>}
        className={`relative z-10 flex flex-col items-center text-center px-6 transition-all duration-1000 ${anim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}
      >
        <p className="text-[#f5d8b8] text-[1rem] tracking-[0.3em] uppercase font-medium mb-4">Connect With Us</p>
        <h2 className="text-white text-[2.75rem] md:text-[3.25rem] font-bold leading-[1.3] mb-4 max-w-2xl">加入 LINE，優先收到<br />新品與優惠通知</h2>
        <p className="text-white/80 text-[1.1875rem] leading-[1.75] mb-10 max-w-xl">
          加入我們的 LINE 官方帳號，第一時間收到新品上架通知、<br className="hidden md:block" />
          限量優惠活動、預約試穿服務，以及專屬穿搭建議。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a href="https://line.me" target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-3 px-8 py-4 bg-[#faf8f5] text-[#3d2b1f] rounded-full text-[1.0625rem] font-bold hover:bg-[#f5e6d8] transition-all cursor-pointer whitespace-nowrap">
            <i className="ri-line-fill text-xl text-[#06C755]"></i>立即加入 LINE 諮詢
          </a>
          <Link to="/contact"
            className="flex items-center gap-2 px-8 py-4 border-2 border-white/60 text-white rounded-full text-[1.0625rem] font-semibold hover:bg-white/15 transition-all cursor-pointer whitespace-nowrap">
            <i className="ri-calendar-check-line"></i>預約到店試穿
          </Link>
        </div>
        <div className="flex flex-wrap justify-center gap-6 mt-12 text-white/70 text-[1rem]">
          {["接收新品上架通知","詢問尺寸與穿搭建議","取得特價活動資訊","預約試穿服務"].map((item, i) => (
            <span key={i} className="flex items-center gap-2">
              <i className="ri-check-line text-[#c9a98a]"></i>{item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
